import { Badge } from "@/components/ui/badge";
import { Home } from "lucide-react";

export const daysOnMarket = (p) => {
  if (p?.listed_date) {
    const d = Math.floor((Date.now() - new Date(p.listed_date).getTime()) / 86400000);
    if (!isNaN(d) && d >= 0) return d;
  }
  return p?.days_on_market || p?.days_on_market === 0 ? Number(p.days_on_market) : null;
};

const short = (n) => n >= 1e6 ? `$${(n / 1e6).toFixed(2)}M` : `$${Math.round(n / 1000)}k`;

export const ListingBadge = ({ p, testId }) => {
  const price = Number(p?.listing_price);
  if (!price) return null;
  const dom = daysOnMarket(p);
  return (
    <Badge className="gap-1 border-0 bg-slate-800 text-white" data-testid={testId}>
      <Home className="h-3 w-3" /> Listed {short(price)}{dom !== null ? ` · ${dom}d on market` : ""}
    </Badge>
  );
};
